const Button = {
  variants: {
    solid: (props: any) => ({
      backgroundColor: props.colorMode === "dark" ? "#3BA9D6" : "#53B5E0",
      color: "#FFFFFF",
      rounded: "10px",
      _hover: {
        backgroundColor: props.colorMode === "dark" ? "#3BA9D6" : "#3BA9D6"
      }
    }),
    lightSolid: (props: any) => ({
      backgroundColor: props.colorMode === "dark" ? "#253136" : "#F7FAFB",
      color: "#53B5E0",
      rounded: "10px",
      border: props.colorMode === "dark" ? "none" : "0.5px solid #53B5E0",
      _hover: {
        backgroundColor: props.colorMode === "dark" ? "#253136" : "#F7FAFB"
      }
    }),
    darkSolid: (props: any) => ({
      backgroundColor: props.colorMode === "dark" ? "#161618" : "#FFFFFF",
      color: props.colorMode === "dark" ? "#F7FAFB" : "#05103D",
      rounded: "10px",
      border:
        props.colorMode === "dark" ? "1px solid #FFFFFF" : "1px solid #161618",
      _hover: {
        backgroundColor: props.colorMode === "dark" ? "#161618" : "#FFFFFF"
      }
    }),
    link: (props: any) => ({
      backgroundColor: "transparant",
      color: props.colorMode === "dark" ? "#F7FAFB" : "#6A6B6C",
      border: "none",
      _hover: {
        backgroundColor: "none"
      }
    })

    // outline: (props: any) => ({
    //   backgroundColor: props.colorMode === "dark" ? "gray.700" : "#dcecf5",
    //   color: props.colorMode === "dark" ? "#53B5E0" : "#53B5E0",
    //   fontWeight: "700",
    //   border: "none",
    //   rounded: "7px",
    //   _hover: {
    //     backgroundColor: props.colorMode === "dark" ? "gray.600" : "#cbe4f1"
    //   }
    // }),

    // filled: (props: any) => ({
    //   backgroundColor: props.colorMode === "dark" ? "#1A202C" : "#05103D",
    //   color: "#FFFFFF",
    //   rounded: "7px",
    //   _hover: {
    //     backgroundColor: props.colorMode === "dark" ? "#2D3748" : "#1a1f40"
    //   }
    // })
  }
};

export default Button;
